@if (isLoading()) {
  <div class="flex-1 flex items-center justify-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
} @else {
  @for (log of transmittalLogs(); track log.id) {
    <div class="log-entry transmittal-grid">
      <div class="contents header">
        <div class="item data-highlighted">
          {{ log.action_date | dayjsFormatter: 'DD/MM/YY' }}
        </div>
        <div class="item title">ACTION</div>
        <div class="item title">TAKEN BY</div>
        <div class="item title">RECEIVED BY</div>
        <div class="item file">
          <app-file-card [maxDesiredLengthPx]="150" [file]="log.cover"></app-file-card>
        </div>
      </div>
      <div class="contents">
        <div class="item data-highlighted">{{ log.action_date | dayjsFormatter: 'h:mmA' }}</div>
        <div class="item data-highlighted">{{ log.actionLabel }}</div>
        <div class="item data-highlighted">{{ log.sender.name }}</div>
        <div class="item data-highlighted">{{ log.receiver.name }}</div>
      </div>

      <div class="contents">
        <div class="item company-name col-start-3">{{ log.sender.company_name }}</div>
        <div class="item company-name">{{ log.receiver.company_name }}</div>
      </div>

      <div class="contents registry-entry-header">
        <div class="item title col-start-1">REGISTRY ITEM</div>
        <div class="item title">SPEC SECTION</div>
        <div class="item title">DESCRIPTION</div>
        <div class="item title">STATUS</div>
      </div>

      @for (entry of log.entries; track entry.id) {
        <div class="contents registry-entry">
          <div class="item col-start-1">{{ entry.custom_id }}</div>
          <div class="item">{{ entry.spec_section }} {{ entry.spec_description }}</div>
          <div class="item">{{ entry.item_description }}</div>
          <div class="item">{{ entry.status | status }}</div>
        </div>
      }
    </div>
  } @empty {
    <div class="text-center text-size_xl font-semibold text-navy-600 mt-12">No transmittal logs to show.</div>
  }
}
